import { useMemo } from 'react';
import FilterTypes from '@constants/FilterTypes';
import { actionTypes } from '../reducer';
import { SUBMISSION_STATUS } from '../constants';
const useFilters = ({ filters, dispatch }) => {
    const onChangeFilter = (fieldName) => (value) => {
        dispatch({ type: actionTypes.FILTER_CHANGED, field: fieldName, value });
    };
    const onToggleFilter = (fieldName) => () => {
        dispatch({ type: actionTypes.FILTER_TOGGLED, field: fieldName });
    };
    const onChangeDateFilter = (fieldName) => (dateFieldName, value) => {
        dispatch({
            type: actionTypes.DATE_RANGE_FILTER_CHANGED,
            field: fieldName,
            dateField: dateFieldName,
            value
        });
    };
    const onSearchChange = (value) => {
        dispatch({ type: actionTypes.SEARCH_CHANGED, search: value });
    };
    const filtersList = useMemo(() => {
        const list = [
            {
                field: 'kitNumber',
                locale: 'kit_number',
                type: 'textBox',
                active: filters.active.kitNumber,
                value: filters.values.kitNumber,
                onChange: onChangeFilter('kitNumber'),
                onToggle: onToggleFilter('kitNumber')
            },
            {
                field: 'submittedAt',
                locale: 'submitted_at',
                type: FilterTypes.DateRangePicker,
                active: filters.active.submittedAt,
                values: filters.values.submittedAt,
                onChange: onChangeDateFilter('submittedAt'),
                onToggle: onToggleFilter('submittedAt')
            },
            {
                field: 'priority',
                locale: 'priority',
                type: 'commonSelect',
                active: filters.active.priority,
                value: filters.values.priority,
                onChange: onChangeFilter('priority'),
                onToggle: onToggleFilter('priority'),
                optionsForSelect: [
                    { value: 'standard', label: 'Standard' },
                    { value: 'rush', label: 'Rush' }
                ]
            },
            {
                field: 'status',
                locale: 'status',
                type: 'commonSelect',
                active: filters.active.status,
                value: filters.values.status,
                onChange: onChangeFilter('status'),
                onToggle: onToggleFilter('status'),
                optionsForSelect: [
                    { value: SUBMISSION_STATUS.SENT, label: 'Sent' },
                    { value: SUBMISSION_STATUS.COMPLETED, label: 'Completed' }
                ]
            }
        ];
        return list;
    }, [filters, dispatch]);
    return { filtersList, onSearchChange };
};
export default useFilters;
